define('GSModel',['backbone', 'bizzabo/models/SyncedModel'], function(Backbone, SyncedModel) {

    var GSModel = SyncedModel.extend({

        get : function(attr) {
            // Call the getter if available
            if (_.isFunction(this.getters[attr])) {
                return this.getters[attr].call(this);
            }

            return Backbone.Model.prototype.get.call(this, attr);
        },

        set : function(key, value, options) {
            // Normalize the key-value into an object
            var attrs = {};
            if (_.isObject(key) || key == null) {
                attrs = key;
                options = value;
            } else {
                attrs = {};
                attrs[key] = value;
            }

            // Go over all the set attributes and call the setter if available
            var undefinedAttr = [];
            for (var attr in attrs) {
                if (_.isFunction(this.setters[attr])) {
                    attrs[attr] = this.setters[attr].call(this, attrs[attr]);
                    if (_.isUndefined(attrs[attr])) {
                        undefinedAttr.push(attr);
                    }
                }
            }
            if (!options || !options.unset) {
                for (var attr in undefinedAttr) {
                    delete attrs[undefinedAttr[attr]];
                }
            }

            return Backbone.Model.prototype.set.call(this, attrs, options);
        },

        getters : {},
        setters : {}
    });

    return GSModel;
});
